import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import NavBar from '@/components/NavBar.vue';
  import LoadingSpinner from '@/components/LoadingSpinner.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(LoadingSpinner),
    _createVNode(NavBar),
    _createVNode(_component_RouterView)
  ], 64))
}
}

})